module.exports = __webpack_public_path__ + "img/Macot_auto.23c866f9.png";